import React from "react";
import PropTypes from "prop-types";

const Documentation = ({ descriptionText, documentationUrl }) => (
  <span className="tw-mr-6 tw-mb-4">
    <a href={documentationUrl} target="_blank">
      {descriptionText}
    </a>
  </span>
);

Documentation.propTypes = {
  descriptionText: PropTypes.string.isRequired,
  documentationUrl: PropTypes.string.isRequired,
};

Documentation.defaultProps = {};

export default Documentation;
